import { useContext } from "react";
import { HostModuleContext } from "../context";
import { ModuleInfo } from "../model";

/**
 * Returns the module hosting the calling component.
 */
export function useHostModule(): ModuleInfo | null {
  const info = useContext<ModuleInfo | null>(HostModuleContext);
  return info;
}
